import { Addon } from '@domain/addon';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

const getEventAddons = async (eventId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/events/${eventId}/add-ons?limit=100`;

  return request({ url, method: RequestMethod.GET });
};

export const getAddonsQueryKey = (eventId: string) => [QUERY_KEYS.getAddons, eventId];

export const useGetAddons = ({ eventId, enabled }: { eventId: string; enabled?: boolean }) => {
  return useGenericQuery<Addon[], RequestError>(getAddonsQueryKey(eventId), () => getEventAddons(eventId), {
    enabled: enabled ?? !!eventId,
  });
};
